import { FormEntry } from './form781A'

/**
 * Represents a selection to view work orders for an inspection area.
 * Used to open the work orders popup from the sidebar.
 */
export interface KVWorkOrdersSelection {
  type: 'workOrders'
  id: string
  kestrelModelId: string
  inspectionAreaId: string
  workOrders: FormEntry[]
}

export const isKVWorkOrdersSelection = (
  markup: unknown
): markup is KVWorkOrdersSelection =>
  markup !== null &&
  typeof markup === 'object' &&
  'type' in markup &&
  (markup as KVWorkOrdersSelection).type === 'workOrders'
